import React from "react";
import { COLORS } from "../utils/constants";

interface BrandNameProps {
  style?: React.CSSProperties;
}

const BrandName: React.FC<BrandNameProps> = ({ style }) => (
  <span
    style={{
      fontWeight: 500,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      display: "inline-block",
      fontSize: 12,
      ...style,
    }}
  >
    <span style={{ color: COLORS.brandPurple }}>SOCIAL</span>
    <span style={{ color: COLORS.brandTeal }}>FLOW</span>
  </span>
);

export default BrandName;
